// src/api/auth.ts
import { request } from '@/utils/request'
import type {
  LoginResponseData,
  LoginRequest,
  RefreshTokenResponse,
  RSAResponse,
  UserInfo,
  CaptchaResponse,
  SmsCodeRequest
} from '@/types/auth'

// 现在这些函数都能正确返回 Promise<LoginResponseData>
export const codeLogin = (data: LoginRequest): Promise<LoginResponseData> => {
  return request.post<LoginResponseData>('/api/auth/code/login', data)
}

export const getCaptcha = (): Promise<CaptchaResponse> => {
  return request.post<CaptchaResponse>('/api/auth/captcha', {})
}

export const sendCode = (data: SmsCodeRequest): Promise<any> => {
  const payload: SmsCodeRequest = {
    ...data,
    deviceId: data.deviceId ?? localStorage.getItem('deviceId') ?? undefined
  }
  return request.post('/api/auth/smscode/v2', payload)
}

export enum SmsCodeType {
  Login = 1,
  BindPhone = 2,
  ChangePhone = 3,
  SetPasswordWechat = 4,
  Register = 5,
  ForgotPassword = 6,
  SetPasswordSms = 7
}

export const passwordLogin = (data: LoginRequest): Promise<LoginResponseData> => {
  return request.post<LoginResponseData>('/api/auth/pwd/login', data)
}

export const logout = (): Promise<any> => {
  return request.post('/api/auth/logout', {})
}

export const refreshTokenRequest = (refreshToken: string,): Promise<RefreshTokenResponse> => {
  return request.post<LoginResponseData>('/api/auth/refresh', { refreshToken })
}

export const register = (phone: string, code: string, keyId: string, password: string): Promise<LoginResponseData> => {
  return request.post<LoginResponseData>('/api/auth/code/register', { phone, code, keyId, password })
}

export const resetPassword = (phone: string, code: string, keyId: string, password: string): Promise<any> => {
  return request.post('/api/auth/pwd/reset', { phone, code, keyId, password })
}

export const rsaPublicKey = (platform: string): Promise<RSAResponse> => {
  return request.post<RSAResponse>('/api/auth/rsa/pkey', { platform })
}

export const userInfo = (): Promise<UserInfo> => {
  return request.post<UserInfo>('/api/user/info', {})
}

export const userClose = (): Promise<String> => {
  return request.post<String>('/api/user/close', {})
}

export const userCollection = (id, action, type): Promise<String> => {
  return request.post<String>('/api/user/collection', { id, action, type })
}

export const updateUserPhone = (phone: string, code: string): Promise<any> => {
  return request.post('/api/update/user/phone', { phone, code })
}

export const updateUserName = (name: string): Promise<any> => {
  return request.post('/api/update/user/name', { name })
}